export const ROOT = 'https://atg-api.d-a.app';
// export const ROOT = 'http://127.0.0.1:10801';
